import styled from "@emotion/styled";
import colors from "styles/colors";
export const StyledDirectoryComponent = styled.div`
  width: 100%;

  .directory-signup-wrapper {
    display: flex;
    justify-content: center;
    background-color: ${colors["white"]};
    padding: 64px;
  }
`;
